import { Routes } from '@angular/router';

import { BlankComponent, FullComponent } from '@app/shared';
import { WebComponent } from '@shared/layouts/web/web.component';

export const AppRoutes: Routes = [
  {
    path: '',
    component: FullComponent,
    children: [
      {
        path: '',
        redirectTo: '/dashboard',
        pathMatch: 'full'
      },
      {
        path: 'dashboard',
        loadChildren: () =>
          import('./dashboard/dashboard.module').then(m => m.DashboardModule)
      }
    ]
  },
  // {
  //   path: '',
  //   component: WebComponent,
  //   children: [
  //     {
  //       path: '',
  //       redirectTo: '/website',
  //       pathMatch: 'full'
  //     },
  //     {
  //       path: 'website',
  //       loadChildren: () =>
  //         import('./website/website.module').then(m => m.WebsiteModule)
  //     }
  //   ]
  // },

  {
    path: '',
    component: BlankComponent,
    children: [
      {
        path: '',
        loadChildren: () =>
          import('./authentication/authentication.module').then(
            m => m.AuthenticationModule
          )
      }
    ]
  },

  {
    path: '**',
    redirectTo: '/404'
  }
];
